export const initialState = {
  unitList: [],
  taskList: [],
  isUnitsLoaded: false,
  unitMessage: "",
  sections:[],
  gpType:''
};
